import React, {useState} from 'react';
import {Input} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";
import {CustomTypography} from "./CustomTypography";
import * as IconsMaterial from "@mui/icons-material";

interface CustomInputPasswordProps {
    value?: string;
    error?: string;
    disabled?: boolean;
    maxLength?: number;
    onChangeText?: (text: string) => void;
    eventSistem?: () => void;
}

function CustomInputPassword({disabled, error, maxLength, eventSistem, ...props}: CustomInputPasswordProps) {
    const {t} = useTranslation("global") as { t: (key: string) => string };
    const [showPassword, setShowPassword] = useState(false);

    const handleInputChange = (event: any) => {
        return event.target.value;
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const {key} = event;
        const upperCaseKey = key.toUpperCase();
        if (upperCaseKey === 'ENTER' && eventSistem) {
            eventSistem()
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className='w-full grid grid-cols-1 custom-input'>
            <div className={'label labelCustom'}>
                    <span
                        className={
                            `${disabled ? 'text-colorDisabled' : 'text-labelColor'} labelCustom normal-case text-[10px] bg-white ml-[18px] px-1 rounded-[5px]`
                        }
                    >
                        {t('Password')}
                    </span>
            </div>
            <div className={`${error ? '-mt-3' : 'input'}`}>
                <Input
                    crossOrigin=''
                    type={showPassword ? "text" : "password"}
                    className={`styleInput min-h-[54px] max-h-[54px] !border !border-gris bg-white text-gray-900 shadow-lg shadow-gray-900/5 
                ring-1 ring-transparent placeholder:text-gray-500 focus:!border-gray-900 focus:!border-t-gray-900 
                focus:ring-gray-900/10`}
                    labelProps={{
                        className: "hidden",
                    }}
                    containerProps={{className: "min-w-[100px]"}}
                    value={props.value}
                    onChange={(e) => {
                        if (props.onChangeText) props.onChangeText(handleInputChange(e))
                    }}
                    onKeyDown={handleKeyDown}
                    error={error !== undefined}
                    style={{fontSize: `$sizeText`}}
                    icon={
                        <div className={'min-h-[35px] flex items-center'}>
                            {showPassword ?
                                <IconsMaterial.VisibilityOff
                                    className="h-5 w-5"
                                    onClick={() => {
                                        togglePasswordVisibility()
                                    }}
                                /> :
                                <IconsMaterial.Visibility
                                    className="h-5 w-5"
                                    onClick={() => {
                                        togglePasswordVisibility()
                                    }}
                                />}
                        </div>
                    }
                />
            </div>
            {error && <CustomTypography variant="small" style={{color: 'red'}}
                                        className="static mt-[12px] font-normal ml-1 text-[10px]" text={error}/>}
        </div>
    );
}

export default CustomInputPassword;
